import { getTrendingView, readView } from "@roc-digital/mxm-base/logic";
import { TagSchema, ZoneSchema } from "@roc-digital/mxm-base/src/data";
import { useMethod } from "@roc-digital/ui-lib";
import { Checkbox } from "./Checkbox";
import React, { useState } from "react";

export interface TrendingViewSectionSelectorProps {
  tags: TagSchema[];
  onChange: (tags: TagSchema[]) => void;  
}

export function TrendingViewSectionSelector(props: TrendingViewSectionSelectorProps) {
  const [tags, setTags] = useState(props.tags);
  const tagsRef = React.useRef(tags);
  tagsRef.current = tags;

  const emitChanges = (tags: TagSchema[]) => {
    setTags(tags);
    props.onChange(tags);
  }

  React.useEffect(() => {
    if(props.tags !== tagsRef.current) {
      setTags(props.tags);
    }
  }, [props.tags]);

  const query = useMethod(readTrendingViewSections, {
    autoRun: []
  });

  const toggleSection = (section: ViewSection) => {
    console.log(section.tags, tags);
    const checked = intersects(section.tags, tags);
    let next = [...tags];
    if(checked) {
      next = next.filter(t => section.tags.includes(t) === false)
    } else {
      next = [...next, ...section.tags];
    }

    next = next.filter((t, i, l) => l.indexOf(t) === i);

    emitChanges(next);
  }

  if(!query.result?.length) {
    return <>No Active View</>;
  }

  const items = query.result.map(section => {
    const checked = intersects(section.tags, tags);
    return <div key={section.name} className="flex flex-row" style={{gap: 8, alignItems: 'center'}}>
      <Checkbox value={checked} changeEvent={() => toggleSection(section)}/>
      <span>{section.name}</span>
    </div>
  })
  
  return <>
    <div>
      {items}
    </div>
  </>;
}

interface ViewSection {
  view: string;
  name: string;
  tags: TagSchema[];
}

async function readTrendingViewSections(): Promise<ViewSection[]> {
  const trending = await getTrendingView();

  if(!trending?.zones?.length) return [];

  let z: ZoneSchema

  const tagZones = trending.zones?.filter(z => z?.source === 'tags');

  return tagZones.map(z => ({
    view: trending.title,
    name: z.title,
    tags: z.tags
  } as ViewSection))
  .filter(s => s.tags?.length);
}

const intersects = (a: TagSchema[], b: TagSchema[]) => {
  if(!a || !b) return false;
  return a.findIndex((a => b.findIndex(b => b.scope === a.scope) > -1)) > -1;
}